import { useTrans } from '@/shared/hooks/useTranslation';
import { Button } from '@/view/shared/Button';
import { CloudOff } from 'lucide-react';

export function AuthErrorFallback() {
  const { t } = useTrans();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="flex w-full max-w-md flex-col items-center gap-4 rounded-2xl border border-separator bg-surface p-8 text-center">
        <CloudOff className="h-10 w-10 text-muted-foreground" aria-hidden />
        <h1 className="text-lg font-semibold">{t('authError.title')}</h1>
        <p className="text-sm text-foreground/80">{t('authError.body')}</p>
        <Button onClick={() => globalThis.location.reload()}>{t('authError.retry')}</Button>
      </div>
    </div>
  );
}
